export const INFINITE_SCROLL = "infinite_scroll" as const
export const LOAD_MORE = "load_more" as const

export type PRODUCT_LOAD_TRIGGER = typeof INFINITE_SCROLL | typeof LOAD_MORE
